import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunkMiddleware from "redux-thunk";
import rootReducer from "../reducers/rootReducer";

export default function configureStore() {
  const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['authentication']
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = createStore(
    persistedReducer,
    process.env.NODE_ENV === "development" ? composeWithDevTools(applyMiddleware(thunkMiddleware, reduxImmutableStateInvariant())) : applyMiddleware(thunkMiddleware)
  );

  const persistor = persistStore(store);

  return { store, persistor };
}



// WEBPACK FOOTER //
// ./src/store/store.util.ts